import PropTypes from "prop-types";

import MDBox from "components/MDBox";
import HelpTooltip from "components/HelpTooltip";

function HelpLabel({ children, helpText, justifyContent }) {
  return (
    <MDBox
      component="span"
      display="inline-flex"
      alignItems="center"
      justifyContent={justifyContent}
      gap={0.75}
      width={justifyContent === "space-between" ? "100%" : "auto"}
    >
      <span>{children}</span>
      <HelpTooltip title={helpText} />
    </MDBox>
  );
}

HelpLabel.defaultProps = {
  justifyContent: "flex-start",
};

HelpLabel.propTypes = {
  children: PropTypes.node.isRequired,
  helpText: PropTypes.string.isRequired,
  justifyContent: PropTypes.string,
};

export default HelpLabel;
